import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RequestAccessStepOneComponent } from './step-one/step-one.component';
import { RequestAccessStepTwoComponent } from './step-two/step-two.component';
import { RequestAccessConfirmationComponent } from './confirmation/confirmation.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'access',
		pathMatch: 'full'
	},
	{
		path: 'step-one',
		component: RequestAccessStepOneComponent
	},
	{
		path: 'access',
		component: RequestAccessStepTwoComponent,
		data: { 'requireToken': false }
	},
	{
		path: 'verify/:token',
		component: RequestAccessStepTwoComponent,
		data: { 'requireToken': true }
	},
	{
		path: 'confirmation/:id',
		component: RequestAccessConfirmationComponent,
		data: { 'requireRequestId': true }
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class RequestAccessRoutingModule {
}
